/**
 * The link an invited person opens, from what the server returned.
 *
 * <p>The server builds it when it knows its own public address; otherwise it is built from the
 * address this screen is served on, which is where the accept page lives too.
 */
export function inviteLinkFor(token: string | null, acceptUrl: string | null): string | null {
  if (acceptUrl) return acceptUrl
  if (!token) return null
  return `${window.location.origin}/accept-invite?token=${encodeURIComponent(token)}`
}

